module.exports = __webpack_public_path__ + "assets/img/onboardingmac.2ed51ae2.gif";